import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Paper, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAuth } from '../auth/AuthContext';
import { getForbiddenHomePath } from '../auth/redirects';

export function ForbiddenPage() {
  const { t } = useTranslation(['auth', 'common']);
  const { session } = useAuth();
  const homePath = getForbiddenHomePath(session);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 420, textAlign: 'center' }}>
        <LockOutlinedIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h5" gutterBottom>
          {t('auth:forbidden_title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {t('auth:forbidden_message')}
        </Typography>
        <Button component={RouterLink} to={homePath} variant="contained">
          {t('auth:back_to_dashboard')}
        </Button>
      </Paper>
    </Box>
  );
}
